export default __webpack_public_path__ + "static/media/button_deposit.49c2d804.svg";